import { arrayContains } from 'Utils';
import Actions from 'Redux/Actions';
import { TRootState } from 'Redux/Reducers';

export const isUserLoading = (state: TRootState) =>
  arrayContains(state.user.openRequests, [
    Actions.authenticationRequest.type,
  ]);



